/* Coral Keepsake: tap-to-fill ready-made messages. Tapping one puts it in its box (the dedication box,
   or the box named by data-ckb-for on the group), where the customer can keep it or change it.
   The preview updates exactly as if they had typed it. */
(function(){
 'use strict';
 const boxFor=group=>{const root=group.closest('.ckb-preview');return root&&root.querySelector('[data-ckb="'+(group.dataset.ckbFor||'dedication')+'"]');};
 function sync(root){
  for(const group of root.querySelectorAll('.ckb-picks')){const box=boxFor(group);if(!box)continue;
   for(const b of group.querySelectorAll('[data-ckb-pick]'))b.setAttribute('aria-pressed',String(box.value.trim()===b.dataset.ckbPick));}
 }
 document.addEventListener('click',e=>{
  const b=e.target.closest&&e.target.closest('[data-ckb-pick]');if(!b)return;
  const group=b.closest('.ckb-picks'),box=group&&boxFor(group);if(!box)return;
  e.preventDefault();box.value=b.dataset.ckbPick;box.dispatchEvent(new Event('input',{bubbles:true}));sync(b.closest('.ckb-preview'));
 });
 document.addEventListener('input',e=>{const root=e.target.closest&&e.target.closest('.ckb-preview');if(root)sync(root);});
})();
/* Coral Keepsake: emoji can't be printed in the book fonts. Take them out as the customer types,
   before the preview reads the box, and say so under the box, instead of blocking the preview. */
(function(){
 'use strict';
 let FIND,ALL;
 try{
  const cls='(?![\\u00a9\\u00ae\\u2122])[\\p{Extended_Pictographic}\\u{1F1E6}-\\u{1F1FF}\\u{1F3FB}-\\u{1F3FF}\\u{E0020}-\\u{E007F}\\uFE0E\\uFE0F\\u200D\\u20E3]';
  FIND=new RegExp(cls,'u');ALL=new RegExp(cls,'gu');
 }catch(e){return;}
 const isBox=t=>t&&t.closest&&t.closest('.ckb-preview')&&(t.tagName==='TEXTAREA'||(t.tagName==='INPUT'&&t.type==='text'));
 function note(box,removed){
  const seen=box._ckbRemoved||(box._ckbRemoved=[]);
  for(const c of removed)if(/\p{Extended_Pictographic}/u.test(c)&&!seen.includes(c))seen.push(c);
  let n=box.parentNode.querySelector('.ckb-emoji-note');
  if(!n){n=document.createElement('p');n.className='ckb-help ckb-emoji-note';n.setAttribute('role','status');n.style.color='#4E7A5E';box.insertAdjacentElement('afterend',n);}
  n.textContent='We’ve taken out '+(seen.length?seen.join(' '):'the emoji')+' because emoji can’t be printed in the book. Everything else is kept.';n.hidden=false;
 }
 function clean(box){
  const v=box.value;if(!v||!FIND.test(v))return false;
  const removed=Array.from(new Set((v.match(ALL)||[]).map(c=>c.replace(/[︎️‍]/g,'')).filter(Boolean))).join(' ');
  const tidy=s=>s.replace(ALL,'').replace(/ {2,}/g,' ');
  let caret=null;try{caret=box.selectionStart;}catch(e){}
  const out=tidy(v);box.value=out;
  if(caret!=null){try{const p=Math.min(tidy(v.slice(0,caret)).length,out.length);box.setSelectionRange(p,p);}catch(e){}}
  note(box,removed);return true;
 }
 document.addEventListener('input',e=>{if(isBox(e.target))clean(e.target);},true);
 document.addEventListener('focusout',e=>{const b=e.target;if(!isBox(b)||!b._ckbRemoved)return;const v=b.value,t=v.replace(/ +([!?.,;:])/g,'$1').replace(/ {2,}/g,' ');if(t!==v){b.value=t;b.dispatchEvent(new Event('input',{bubbles:true}));}},true);
 function sweep(){for(const b of document.querySelectorAll('.ckb-preview textarea, .ckb-preview input[type="text"]'))if(clean(b))b.dispatchEvent(new Event('input',{bubbles:true}));}
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sweep);else sweep();
})();
